<template>
  <div class="container-fluid">
    <div class="row" id="app">
      <!-- Inputs Section -->
      <div class="col-12 col-lg-6 engineering-paper">
        <TopbarNav />
        <hr/>
            <!-- Section 1: Material Properties -->
                <div class="row">
                  <div class="col-6">
                    <label for="phi_c">φc:</label>
                  </div>
                  <div class="col-6">
                    <input type="number" name="phi_c" v-model="phi_c" step="0.01" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label for="fc">f'c:</label>
                  </div>
                  <div class="col-6">
                    <input type="number" name="fc" v-model="fc" />MPa
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label for="lambda">λ:</label>
                  </div>
                  <div class="col-6">
                    <input type="number" name="lambda" v-model="lambda" step="0.1" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label for="phi_s">φs:</label>
                  </div>
                  <div class="col-6">
                    <input type="number" name="phi_s" v-model="phi_s" step="0.01" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label for="fy">fy:</label>
                  </div>
                  <div class="col-6">
                    <input type="number" name="fy" v-model="fy" />MPa
                  </div>
                </div>
            <!-- Section 2: Geometry -->
                <div class="row">
                  <div class="col-6">
                    <label for="thickness">Thickness:</label>
                  </div>
                  <div class="col-6">
                    <input type="number" name="thickness" v-model="thickness" />mm
                  </div>
                </div>
            <!-- Section 3: Forces -->
                <div class="row">
                  <div class="col-6">
                    <label for="Vf">Vf:</label>
                  </div>
                  <div class="col-6">
                    <input type="number" name="Vf" v-model="Vf" />kN/m
                  </div>
                </div>
            <!-- Section 4: Reinforcement -->
                <div class="row">
                  <div class="col-6">
                    <label for="horizontal_bar">Horizontal Bar:</label>
                  </div>
                  <div class="col-6">
                    <select name="horizontal_bar" v-model="horizontal_bar">
                      <option v-for="bar in bar_data" :key="bar.bar_size" :value="bar.bar_size">
                        {{ bar.bar_size }}M
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label for="vertical_bar">Vertical Bar:</label>
                  </div>
                  <div class="col-6">
                    <select name="vertical_bar" v-model="vertical_bar">
                      <option v-for="bar in bar_data" :key="bar.bar_size" :value="bar.bar_size">
                        {{ bar.bar_size }}M
                      </option>
                    </select>
                  </div>
                </div>
                <div v-if="pin_ties_required">
                  <hr/>
                  <h5>Pin Tie Configuration</h5>
                  <div class="row">
                    <div class="col-6">
                      <label for="pin_tie_size">Pin Tie Size:</label>
                    </div>
                    <div class="col-6">
                      <select name="pin_tie_size" v-model="pin_tie_size">
                        <option v-for="bar in bar_data" :key="bar.bar_size" :value="bar.bar_size">
                          {{ bar.bar_size }}M
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <label for="sv">Vertical Spacing, s<sub>v</sub>:</label>
                    </div>
                    <div class="col-6">
                      <input type="number" name="sv" v-model="sv" />mm
                    </div>
                  </div>
                  <div class="alert alert-warning" v-if="sv > thickness / 2 || pin_tie_size != suggested_pin_tie_size">
                    <ul class="mb-0">
                      <li v-if="sv > thickness / 2">Vertical spacing of shear reinforcement to be less than or equal wall thickness divided by two (s<sub>v</sub> ≤ h/2)</li>
                      <li v-if="pin_tie_size != suggested_pin_tie_size">For wall thickness of {{ thickness }}mm, the suggested rebar size is {{ suggested_pin_tie_size }}M</li>
                    </ul>
                  </div>
                </div>
                <hr/>
                <h5>Rebar Properties</h5>
                <table class="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th><label>Bar Size</label></th>
                      <th><label>Cover (mm)</label></th>
                      <th><label>Bar Diameter (mm)</label></th>
                      <th><label>Bar Area (mm²)</label></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(bar, index) in bar_data" :key="bar.bar_size">
                      <td>{{ bar.bar_size }}M</td>
                      <td><input type="number" v-model="bar_data[index].cover" /></td>
                      <td>{{ bar.bar_diameter }}</td>
                      <td>{{ bar.bar_area }}</td>
                    </tr>
                  </tbody>
                </table>
      </div>
      <!-- Report Section -->
      <div class="col-12 col-lg-6 engineering-paper">
        <div class="row mt-2">
          <div class="col-9">
            <KaTeXComponent :expression="'V_f = ' + Vf + ' \\text{ kN/m}'" />
          </div>
          <div class="col-3">
            <p class="fst-italic">
              Factored shear force
            </p>
          </div>
        </div>
        <hr/>
        <div class="row mt-2">
          <div class="col-9">
            <KaTeXComponent :expression="'d_{bh} = ' + horizontal_bar_data.bar_diameter + ' \\text{ mm}'" />
          </div>
          <div class="col-3">
            <p class="fst-italic">
              Horizontal rebar diameter ({{ horizontal_bar }}M)
            </p>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-9">
            <KaTeXComponent :expression="'d_{bv} = ' + vertical_bar_data.bar_diameter + ' \\text{ mm}'" />
          </div>
          <div class="col-3">
            <p class="fst-italic">
              Vertical rebar diameter ({{ vertical_bar }}M)
            </p>
          </div>
        </div>
        <hr/>
        <div class="row mt-2" v-if="d">
          <div class="col-9">
            <KaTeXComponent :expression="'d = h - \\text{cover} - d_{bv}/2 = ' + thickness + ' - ' + vertical_bar_data.cover + ' - ' + (vertical_bar_data.bar_diameter / 2).toFixed(1) + ' = ' + d.toFixed(1) + ' \\text{ mm}'" />
          </div>
          <div class="col-3">
            <p class="fst-italic">
              Effective depth
            </p>
          </div>
        </div>
        <div class="row mt-2" v-if="dv">
          <div class="col-9">
            <KaTeXComponent :expression="'d_v = \\max(0.9d, 0.72h) = \\max(' + (0.9 * d).toFixed(1) + ', ' + (0.72 * thickness).toFixed(1) + ') = ' + dv.toFixed(1) + ' \\text{ mm}'" />
          </div>
          <div class="col-3">
            <p class="fst-italic">
              Effective shear depth
            </p>
          </div>
        </div>
        <div class="row mt-2" v-if="Vr_max">
          <div class="col-9">
            <KaTeXComponent :expression="'V_{r,\\text{max}} = 0.25 \\phi_c f_c\' d_v = 0.25 \\times ' + phi_c + ' \\times ' + fc + ' \\times ' + dv.toFixed(1) + ' = ' + Vr_max.toFixed(1) + ' \\text{ kN/m}'" />
          </div>
          <div class="col-3">
            <p class="fst-italic">
              Maximum shear resistance (Cl. 11.3.3, Eq. 11.5)
            </p>
          </div>
        </div>
        <div class="row mt-2" v-if="Vf_exceeds_Vr_max !== null">
          <div class="col-9">
            <KaTeXComponent :expression="'V_f ' + (Vf_exceeds_Vr_max ? '>' : '\\leq') + ' V_{r,\\text{max}} \\rightarrow ' + Vf + (Vf_exceeds_Vr_max ? ' > ' : ' \\leq ') + Vr_max.toFixed(1) + ' \\text{ kN/m}'" />
          </div>
          <div class="col-3">
            <p :class="['fst-italic', Vf_exceeds_Vr_max ? 'text-danger fw-bold' : '']">
              {{ Vf_exceeds_Vr_max ? 'Increase wall thickness' : 'Wall thickness adequate' }}
            </p>
          </div>
        </div>
        <div v-if="!Vf_exceeds_Vr_max">
        <div class="row mt-2" v-if="beta_unreinforced">
          <div class="col-9">
            <KaTeXComponent :expression="'\\beta = ' + (pin_ties_required ? '0.18' : (thickness < 300 ? '0.21' : '\\frac{230}{1000+d} = \\frac{230}{1000+' + d.toFixed(1) + '} = ' + beta_unreinforced.toFixed(2))) " />
          </div>
          <div class="col-3">
            <p class="fst-italic">
              {{ pin_ties_required ? 'Minimum shear reinforcement provided' : (thickness < 300 ? 'If t < 300mm, unreinforced wall' : 'If t ≥ 300mm, unreinforced wall') }}
            </p>
          </div>
        </div>
        <div class="row mt-2" v-if="Vc">
          <div class="col-9">
            <KaTeXComponent :expression="'V_{c} = \\phi_c \\lambda \\beta \\sqrt{f_c\'} d_v'" />
          </div>
          <div class="col-3">
            <p class="fst-italic">
              Concrete shear resistance (Cl. 11.3.4)
            </p>
          </div>
        </div>
        <div class="row" v-if="Vc">
          <div class="col-9">
            <KaTeXComponent :expression="'V_{c} = ' + phi_c + ' \\times ' + lambda + ' \\times ' + beta.toFixed(2) + ' \\times \\sqrt{' + fc + '} \\times ' + dv.toFixed(1) + ' = ' + Vc.toFixed(1) + ' \\text{ kN/m}'" />
          </div>
          <div class="col-3">
          </div>
        </div>
        <div class="row mt-2" v-if="pin_ties_required !== null">
          <div class="col-9">
            <KaTeXComponent :expression="'V_f ' + (pin_ties_required ? '>' : '\\leq') + ' V_c \\rightarrow ' + Vf + (pin_ties_required ? ' > ' : ' \\leq ') + Vc.toFixed(1) + ' \\text{ kN/m}'" />
          </div>
          <div class="col-3">
            <p :class="['fst-italic', pin_ties_required ? 'text-danger fw-bold' : '']">
              {{ pin_ties_required ? 'Pin ties REQUIRED' : 'Pin ties NOT REQUIRED' }}
            </p>
          </div>
        </div>
        <div v-if="pin_ties_required">
          <div class="row mt-2" v-if="Vs !== null">
            <div class="col-9">
              <KaTeXComponent :expression="'V_s = V_f - V_c = ' + Vf + ' - ' + Vc.toFixed(1) + ' = ' + Vs.toFixed(1) + ' \\text{ kN/m}'" />
            </div>
            <div class="col-3">
              <p class="fst-italic">
                Shear resisted by reinforcement (Cl. 11.3.3, Eq. 11.5)
              </p>
            </div>
          </div>
          <div class="row mt-2" v-if="Av_min">
            <div class="col-9">
              <KaTeXComponent :expression="'A_{v,\\text{min}} = 0.06 \\sqrt{f_c\'} \\times 1000 \\times s_v / f_y = 0.06 \\times \\sqrt{' + fc + '} \\times 1000 \\times ' + sv + ' / ' + fy + ' = ' + Av_min.toFixed(2) + ' \\text{ mm}^2\\text{/m}'" />
            </div>
            <div class="col-3">
              <p class="fst-italic">
                Minimum shear reinforcement (Cl. 11.2.8.2)
              </p>
            </div>
          </div>
          <div class="row mt-2" v-if="theta">
            <div class="col-9">
              <KaTeXComponent :expression="'\\theta = ' + theta + '^\\circ'" />
            </div>
            <div class="col-3">
              <p class="fst-italic">
                {{ thickness > 300 ? '35° or 42° if t>300mm' : '35° or 42° if t>300mm' }}
              </p>
            </div>
          </div>
          <div class="row mt-2" v-if="Av_req">
            <div class="col-9">
              <KaTeXComponent :expression="'A_{v,\\text{req}} = \\max(A_{v,\\text{min}}, \\frac{V_s \\times 1000 \\times s_v}{\\phi_s f_y d_v (1/\\tan(\\theta))}) = ' + Av_req.toFixed(2) + ' \\text{ mm}^2\\text{/m}'" />
            </div>
            <div class="col-3">
              <p class="fst-italic">
                Required shear reinforcement (Cl. 11.3.5.1)
              </p>
            </div>
          </div>
          <div class="row mt-2" v-if="sh">
            <div class="col-9">
              <KaTeXComponent :expression="'s_h = \\max(600, \\frac{1000}{\\max(A_{v,\\text{min}}, A_{v,\\text{req}})} \\times A_{\\text{pintie}}) = \\max(600, \\frac{1000}{' + Math.max(Av_min, Av_req).toFixed(2) + '} \\times ' + pin_tie_bar_data.bar_area + ') = ' + sh.toFixed(0) + ' \\text{ mm}'" />
            </div>
            <div class="col-3">
              <p class="fst-italic">
                Horizontal pin tie spacing
              </p>
            </div>
          </div>
          <div class="row mt-2" v-if="Vr">
            <div class="col-9">
              <KaTeXComponent :expression="'V_r = V_s + V_c = ' + Vs.toFixed(1) + ' + ' + Vc_unreinforced.toFixed(1) + ' = ' + Vr.toFixed(1) + ' \\text{ kN/m}'" />
            </div>
            <div class="col-3">
              <p class="fst-italic">
                Total shear resistance
              </p>
            </div>
          </div>
        </div>
        <hr v-if="pin_ties_required"/>
        <div v-if="pin_ties_required">
          <h5>Design Summary</h5>
          <div class="row mt-2">
            <div class="col-9">
              <KaTeXComponent :expression="'V_r = ' + Vr.toFixed(1) + ' \\text{ kN/m}'" />
            </div>
            <div class="col-3">
              <p class="fst-italic">
                Wall shear resistance
              </p>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-9">
              <KaTeXComponent :expression="'\\text{Pin ties required: } ' + pin_tie_size + 'M \\text{ @ } ' + sv + 'V + ' + pin_tie_size + 'M \\text{ @ } ' + sh + 'H'" />
            </div>
            <div class="col-3">
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12">
              <p class="fst-italic">Pin ties to be hooked around horizontal reinforcement with 135 degrees hook at interior side and 90 degree hook at exterior side.</p>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <!-- <div class="row mt-3">
      <div class="col-12">
        <h5>Comments</h5>
        <div class="mt-2">
          <p>Should the √f'c term in the shear resistance formula be limited to 8 MPa?</p>
          <p>For large wall thickness, the value of β for the unreinforced condition falls below 0.18, is this correct?</p>
          <p>What is the clause for the formula used for θ?</p>
          <p>What is the source for suggested pin tie bar size per wall thickness?</p>
          <p>Shouldn't we calculate V_s again after calculation of s_h? The initial V_s calculated is the required V_s.</p>
          <p>What is the source for which side to have 135 degrees hook?</p>
          <p>Shouldn't spacing of vertical rebar factor into the horizontal spacing of the pin ties?</p>
          <p>Shouldn't spacing of horizontal rebar factor into the vertical spacing of the pin ties?</p>
          <p>What is the source of s_v to be smaller than half of wall thickness?</p>
          <p>Why are we using s_h for calculation of the shear strength of the wall?</p>
        </div>
      </div>
    </div> -->
  </div>
</template>

<!-- Script -->
<script>
import TopbarNav from "@/components/TopbarNav.vue";

  export default {
    name: "FoundationWall",
    components: {
      TopbarNav: TopbarNav
    },
    data: function () {
      return {
        phi_c: 0.65,
        fc: 30,
        lambda: 1.0,
        phi_s: 0.85,
        fy: 400,
        Vf: 34,
        thickness: 300,
        bar_data: [
          { bar_size: 10, cover: 40, bar_diameter: 11.3, bar_area: 100 },
          { bar_size: 15, cover: 40, bar_diameter: 16, bar_area: 200 },
          { bar_size: 20, cover: 40, bar_diameter: 19.5, bar_area: 300 },
          { bar_size: 25, cover: 40, bar_diameter: 25.2, bar_area: 500 },
          { bar_size: 30, cover: 45, bar_diameter: 29.9, bar_area: 700 },
          { bar_size: 35, cover: 55, bar_diameter: 35.7, bar_area: 1000 }
        ],
        horizontal_bar: 15,
        vertical_bar: 15,
        sv: 150,
        pin_tie_size: null
      };
    },
    mounted() {
      this.pin_tie_size = this.suggested_pin_tie_size;
      this.sv = this.thickness / 2;
    },
    computed: {
      vertical_bar_data: function() {
        return this.bar_data.find(bar => bar.bar_size === this.vertical_bar);
      },
      horizontal_bar_data: function() {
        return this.bar_data.find(bar => bar.bar_size === this.horizontal_bar);
      },
      d: function() {
        if (!this.vertical_bar_data) return null;
        return this.thickness - this.vertical_bar_data.cover - (this.vertical_bar_data.bar_diameter / 2);
      },
      dv: function() {
        if (!this.d) return null;
        return Math.max(0.9 * this.d, 0.72 * this.thickness);
      },
      Vc_unreinforced: function() {
        if (!this.beta_unreinforced || !this.dv) return null;
        return this.phi_c * this.lambda * this.beta_unreinforced * Math.sqrt(this.fc) * 1000 * this.dv / 1000;
      },
      Vc_reinforced: function() {
        if (!this.beta_reinforced || !this.dv) return null;
        return this.phi_c * this.lambda * this.beta_reinforced * Math.sqrt(this.fc) * 1000 * this.dv / 1000;
      },
      pin_ties_required: function() {
        if (!this.Vc_unreinforced || !this.Vf) return null;
        return this.Vf > this.Vc_unreinforced;
      },
      Vc: function() {
        if (this.pin_ties_required && this.Vc_reinforced) {
          return this.Vc_reinforced;
        }
        return this.Vc_unreinforced;
      },
      beta_unreinforced: function() {
        if (this.thickness < 300) {
          return 0.21;
        } else {
          return 230 / (1000 + this.d);
        }
      },
      beta_reinforced: function() {
        return 0.18;
      },
      beta: function() {
        return this.pin_ties_required ? this.beta_reinforced : this.beta_unreinforced;
      },
      Vr_max: function() {
        if (!this.dv) return null;
        return 0.25 * this.phi_c * this.fc * 1000 * this.dv / 1000;
      },
      Vf_exceeds_Vr_max: function() {
        if (!this.Vr_max || !this.Vf) return null;
        return this.Vf > this.Vr_max;
      },
      Av_min: function() {
        if (!this.fc || !this.sv) return null;
        return 0.06 * Math.sqrt(this.fc) * 1000 * this.sv / this.fy;
      },
      theta: function() {
        return this.thickness > 300 ? 35 : 42;
      },
      Vs: function() {
        if (!this.Vf || !this.Vc) return null;
        if (this.Vf <= this.Vc) return 0;
        return this.Vf - this.Vc;
      },
      Av_req: function() {
        if (!this.Vs || !this.phi_s || !this.fy || !this.dv || !this.theta || !this.sv) return null;
        if (this.Vs === 0) return 0;
        const theta_rad = this.theta * Math.PI / 180;
        return Math.max(this.Av_min, (this.Vs * 1000 * this.sv) / (this.phi_s * this.fy * this.dv * (1 / Math.tan(theta_rad))));
      },
      pin_tie_bar_data: function() {
        return this.bar_data.find(bar => bar.bar_size === this.pin_tie_size);
      },
      sh: function() {
        if (!this.Av_min || !this.Av_req || !this.pin_tie_bar_data) return null;
        const calculated_sh = (1000 / Math.max(this.Av_min, this.Av_req)) * this.pin_tie_bar_data.bar_area;
        const min_sh = Math.max(calculated_sh, 600);
        return Math.floor(min_sh / 25) * 25;
      },
      Vr: function() {
        if (!this.Vs || !this.Vc) return null;
        return this.Vs + this.Vc;
      },
      suggested_pin_tie_size: function() {
        if (this.thickness <= 350) return 10;
        if (this.thickness <= 450) return 15;
        if (this.thickness <= 500) return 20;
        if (this.thickness <= 550) return 25;
        return 25;
      }
    }
  };
</script>

<style scoped>
</style>